import { render } from "./TeamManager.vue?vue&type=template&id=e4d56c4e&scoped=true"
import script from "./TeamManager.vue?vue&type=script&lang=js"
export * from "./TeamManager.vue?vue&type=script&lang=js"

import "./TeamManager.vue?vue&type=style&index=0&id=e4d56c4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4d56c4e"]])

export default __exports__